export default "__VITE_ASSET__CR2frjv6__"